import { render, staticRenderFns } from "./novoDesafio.vue?vue&type=template&id=6157e9e7&"
import script from "./novoDesafio.vue?vue&type=script&lang=js&"
export * from "./novoDesafio.vue?vue&type=script&lang=js&"
import style0 from "./novoDesafio.vue?vue&type=style&index=0&lang=css&"
import style1 from "./novoDesafio.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports